import {
    GridColumnMenuFilter,
    GridColumnMenuCheckboxFilter,
    GridColumnMenuProps
} from '@progress/kendo-react-grid';

export const ColumnMenuDefaultFilter = (props: GridColumnMenuProps) => {
    return (
        <div>
            <GridColumnMenuFilter {...props} expanded={true} />
        </div>
    );
}

export const ColumnMenuCheckboxFilter = (props: GridColumnMenuProps) => {
    return (
        <div>
            <GridColumnMenuCheckboxFilter {...props} data={[]} expanded={true} searchBox={() => null} />
        </div>
    );
}